import { Video, Upload, Link } from "lucide-react";
import { Uploader } from "../../components";

interface QuickActionsProps {
  handleClick?: (option: string) => void;
  onFileEvent?: (event: string, data: any, cb?: any) => any;
}

const actions = [
  {
    id: "video",
    icon: Video,
    title: "VIDEOS",
    description: "Upload video content",
    // color: '#3b82f6',
    type: "uploader",
    datatype: "VIDEO",
    asset_type: "video",
  },
  // {
  //   id: 'shorts',
  //   icon: Scissors,
  //   title: 'SHORTS',
  //   description: 'Upload Shorts/Reels videos',
  //   color: '#10b981',
  //   type: 'uploader',
  //   datatype: 'VIDEO',
  //   asset_type: 'shorts',
  // },
  // {
  //   id: 'audio',
  //   icon: Mic,
  //   title: 'AUDIO',
  //   description: 'Upload audio and podcasts',
  //   // color: '#f59e0b',
  //   type: 'uploader',
  //   datatype: 'AUDIO',
  //   asset_type: 'audio',
  // },
  // {
  //   id: 'library',
  //   icon: FolderOpen,
  //   title: 'LIBRARY',
  //   description: 'Upload to content library',
  //   color: '#8b5cf6',
  //   type: 'uploader',
  //   datatype: 'VIDEO',
  //   asset_type: 'library',
  // },
  {
    id: "CUSTOM_UPLOADS",
    icon: Upload,
    title: "CUSTOM UPLOAD",
    description: "Upload via FTP, GDrive...",
    // color: '#ef4444',
    type: "action",
  },
  {
    id: "EMBED",
    icon: Link,
    title: "EMBED",
    description: "Embed youtube, facebook, stream url",
    color: "#6366f1",
    type: "action",
    asset_type: "embed",
  },
];

export const QuickActions = ({
  handleClick,
  onFileEvent,
}: QuickActionsProps) => {
  return (
    <div className="card mb-3">
      <div className="px-3 pb-2 mb-3">
        <div className="py-3 mb-1 border-bottom w-100 text-secondary">
          Want to see metrics on your recent video, upload and publish a video
          to get started
        </div>
        <div className="g-3 m-auto">
          {actions.map((action) => {
            const Icon = action.icon;
            if (action.type === "uploader" && onFileEvent) {
              return (
                <div key={action.id} className="">
                  <Uploader
                    id={action.id}
                    type={action.asset_type}
                    onFileEvent={onFileEvent}
                    datatype={action.datatype || ""}
                    size="100%"
                  >
                    <div className="quick-action d-flex text-start">
                      <div className="border p-2">
                        <Icon size={20} />
                      </div>
                      <div className="ms-3 flex-grow-1">
                        <div className="fw-medium">{action.title}</div>
                        <small>{action.description}</small>
                      </div>
                    </div>
                  </Uploader>
                </div>
              );
            } else {
              return (
                <div key={action.id} className="">
                  <div
                    className="quick-action d-flex text-start"
                    onClick={() => handleClick?.(action.id)}
                  >
                    <div className="border p-2">
                      <Icon size={20} />
                    </div>
                    <div className="ms-3 flex-grow-1">
                      <div className="fw-medium">{action.title}</div>
                      <small>{action.description}</small>
                    </div>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};
